/**
 * Blog Post Redirect Handler
 * On 404 pages, redirects blog post URLs to carolinehirons.com
 */
class BlogRedirectHandler {
  constructor() {
    this.newStoreUrl = 'https://carolinehirons.com';
    this.currentPath = window.location.pathname;
    this.init();
  }

  /**
   * Initialize the redirect handler - only runs on 404 pages for blog URLs
   */
  init() {
    if (this.isOn404Page() && this.isBlogPath()) {
      this.handleBlogRedirect();
    }
  }

  /**
   * Check if we're on a 404 page
   * @returns {boolean} True if on 404 page
   */
  isOn404Page() {
    return document.body.classList.contains('template-404') ||
           document.title.includes('404') ||
           document.title.includes('Not Found');
  }

  /**
   * Check if current path is a blog article URL
   * @returns {boolean} True if path matches blog article pattern
   */
  isBlogPath() {
    return this.currentPath.includes('/blogs/') && this.currentPath.split('/').length >= 4;
  }

  /**
   * Handle blog redirect flow
   */
  async handleBlogRedirect() {
    this.showLoadingState();

    const postExistsOnCH = await this.checkPostExists();

    setTimeout(() => {
      if (postExistsOnCH) {
        window.location.href = `${this.newStoreUrl}${this.currentPath}`;
      } else {
        window.location.href = this.newStoreUrl;
      }
    }, 1000);
  }

  /**
   * Check if a blog post exists at the given URL
   * @returns {Promise<boolean>} True if post exists, false otherwise
   */
  async checkPostExists() {
    try {
      const searchUrl = `${this.newStoreUrl}/search/suggest.json?q=${this.getArticleSlug()}&resources[type]=article`;
      const searchResponse = await fetch(searchUrl);

      if (searchResponse.ok) {
        const data = await searchResponse.json();
        const articleSlug = this.getArticleSlug();

        if (data.resources && data.resources.results && data.resources.results.articles) {
          return data.resources.results.articles.some(article =>
            article.url && article.url.includes(articleSlug)
          );
        }
      }
    } catch (error) {
      console.error('Error checking if post exists:', error);
    }

    return false;
  }

  /**
   * Extract the article slug from the current path
   * @returns {string} The article slug
   */
  getArticleSlug() {
    const pathParts = this.currentPath.split('/');
    return pathParts[pathParts.length - 1];
  }

  /**
   * Show loading state while redirecting
   */
  showLoadingState() {
    if (document.querySelector('.article-template__loading')) {
      return;
    }

    const targetContainer = document.querySelector('main') ||
                           document.querySelector('.page-width') ||
                           document.querySelector('.shopify-section:first-of-type');

    if (targetContainer) {
      const loadingMessage = document.createElement('div');
      loadingMessage.className = 'article-template__loading';
      loadingMessage.innerHTML = `
        <div class="article-template__loading-content">
          <div class="loading-spinner"></div>
          <p>Redirecting to Caroline Hirons...</p>
        </div>
      `;

      targetContainer.insertBefore(loadingMessage, targetContainer.firstChild);

      const sections = document.querySelectorAll('section:not(.blog-redirect-handler)');
      sections.forEach(section => {
        if (!section.classList.contains('blog-redirect-handler')) {
          section.style.display = 'none';
        }
      });
    }
  }
}

if (!window.blogRedirectHandlerInitialized) {
  window.blogRedirectHandlerInitialized = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new BlogRedirectHandler();
    });
  } else {
    new BlogRedirectHandler();
  }
}